import { t } from 'i18next';

export const STATION_STAGES_DEPRECATED = 'Deprecated';

export const STAGE_MESSAGES = {
  updating: t('stationStageUpdating'),
  updated: t('stationStageUpdated'),
  error: t('stationStageError'),
  deprecateTitle: t('stationStageDeprecateTitle'),
  deprecateWarning: t('stationStageDeprecateWarning'),
  deprecateConsequences: [
    t('stationStageDeprecateConsequences1'),
    t('stationStageDeprecateConsequences2'),
    t('stationStageDeprecateConsequences3'),
  ],
  deprecateConfirm: t('stationStageDeprecateConfirm'),
  deprecateButton: t('stationStageDeprecateButton'),
  cancelButton: t('stationStageCancelButton'),
};

export const DEPRECATE_MODAL_CONSTANTS = {
  title: t('stationStageDeprecateTitle'),
  okText: t('stationStageDeprecateButton'),
  cancelText: t('stationStageCancelButton'),
  content: {
    intro: t('stationStageDeprecateWarning'),
    list: [
      t('stationStageDeprecateConsequences1'),
      t('stationStageDeprecateConsequences2'),
      t('stationStageDeprecateConsequences3'),
    ],
    confirmation: t('stationStageDeprecateConfirm'),
  },
};
